import React from 'react';
import { Stack, Row } from 'react-bootstrap';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import { useAssessmentsDataContext } from '../../providers/assessments-data-provider';
import ReactMarkdown from 'react-markdown';

function SelfPacedQuestionHeader({ question }) {
  const { checkAnswersForPage } = useAssessmentsDataContext();
  const q = question.question;
  const questionType = q.question.anchoring.type.toLowerCase();

  const handleMessageChange = (e) => {
    const value = e.target.value;
    q.answer = value;
    checkAnswersForPage();
  };

  return (
    <div className="pt-4 pb-3 w-100">
      <Stack>
        <div className="mx-auto">{`${q.questionNumber}.`}</div>
        <div className="w-25 mx-auto">
          <hr
            style={{
              border: 'none',
              borderBottom: '2px solid black',
            }}
          />
        </div>
        {q.question.title && (
          <>
            <div className="d-flex w-75 mx-auto pt-3 text-larger text-bolder justify-content-center">
              {q.question.title}
            </div>
            <br />
          </>
        )}
        <div className="d-block w-75 mx-auto pt-3 text-larger">
          <ReactMarkdown className="question-md">{q.question.body}</ReactMarkdown>
        </div>
        {questionType === 'text' && (
          <Row key={q.question.id} className="w-75 mx-auto p-3 justify-content-center">
            <FloatingLabel controlId="floatingTextarea2">
              <Form.Control
                onChange={handleMessageChange}
                as="textarea"
                placeholder="Leave a comment here"
                style={{ height: '100px' }}
              />
            </FloatingLabel>
          </Row>
        )}
      </Stack>
    </div>
  );
}

export default SelfPacedQuestionHeader;
